import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Formik } from "formik";
import { string, object } from "yup";
import { Button, TextField, Card, Typography } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { partnerRequest } from "features/AddPartner/partnerSlice";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: "1rem",
  },
  cardBackground: {
    padding: "10px",
    border: "1px solid",
  },
  pagination: {
    marginBottom: "60px",
    marginLeft: "auto",
    margincenter: "auto",
  },
  filter: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    padding: "1rem",
  },
  formStyle: {
    textAlign: "center",
    margin: "auto",
    width: "50%",
  },
  center: {
    textAlign: "center",
  },
  buttonSubmit: {
    marginBottom: "20px",
    marginTop: "20px", 
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    }, 
  },
  paddingTop: {
    paddingTop: "20px",
  },
  heading: {
    color: "#45b77c",
  },
 
});

export default function AddNews() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const loaderDisplay = useSelector((state) => state.addPartner.loading);
  const message = useSelector((state) => state.addPartner.message);
  useEffect(() => {
    if (message.length > 0) {
      setOpen(true);
    }
  }, [message]);
  const validationSchema = object().shape({
    email: string().email("Invalid email address").required("Required"),
    userName: string().required("Required"),
  });

  const onFormSubmit = (values, { resetForm }) => {
    dispatch(partnerRequest([values]));
    resetForm();
  };

  const initialValues = {
    email: "",
    userName: "",
  };

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={3} className={classes.center}>
          <Grid item xs={12}>
            <Typography variant="h4" component="h4" className={classes.heading}>
              Add Partner
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Card className={classes.cardBackground}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onFormSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit
                }) => (
                  <form onSubmit={handleSubmit} className={classes.formStyle}>
                    <div className={classes.paddingTop}>
                      <Grid item xs={12}>
                        <TextField
                          error={touched.email && !!errors.email}
                          name="email"
                          id="formEmail"
                          label="Email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          helperText={touched.email ? errors.email : false}
                          variant="outlined"
                          fullWidth
                          color="primary"
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="User Name"
                          type="text"
                          variant="outlined"
                          name="userName"
                          id="formUserName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.userName}
                          helperText={
                            touched.userName ? errors.userName : false
                          }
                          error={touched.userName && !!errors.userName}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonSubmit}
                          onClick={handleSubmit}
                        >
                          Add Partner
                        </Button>
                      </Grid>
                    </div>
                  </form>
                )}
              </Formik>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Snackbar autoHideDuration={4000} onClose={handleClose} open={open} >
        <Alert
         severity={message === "Failed" ? "error" : "success"}
          onClose={handleClose}
        >
          <p className="message">{message}</p>
        </Alert>
      </Snackbar>
      {loaderDisplay ? <LinearProgress className="loader" /> : false}
    </>
  );
}
